import { Routes } from '@angular/router';
import { ReviewComponent } from '../paragraph-review/review/review.component';

export const routes: Routes = [
  {
    path: '',
    component: ReviewComponent,
  },
];
